import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft, Check } from "lucide-react";
import Logo from "../components/Logo";
import api, { formatApiErrorDetail } from "../lib/api";

export default function MotDePasseOublie() {
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        try {
            await api.post("/auth/forgot-password", { email: email.trim() });
            setDone(true);
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || "Erreur — réessayez.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div data-testid="page-mdp-oublie" className="min-h-screen bg-ink-800 text-white flex flex-col">
            <div className="px-6 md:px-12 py-6">
                <Link to="/login" data-testid="mdp-back-login" className="inline-flex items-center gap-2 text-white/60 hover:text-ice text-sm">
                    <ArrowLeft size={16} /> Retour à la connexion
                </Link>
            </div>
            <div className="flex-1 flex items-center justify-center px-6 py-10">
                <div className="w-full max-w-md">
                    <div className="text-center mb-10">
                        <Logo variant="mark" className="h-24 w-auto mx-auto" />
                        <h1 className="font-serif text-4xl mt-8">Mot de passe oublié ?</h1>
                        <p className="mt-4 text-base text-white/70 max-w-sm mx-auto">
                            Indiquez votre email. Notre équipe vous transmettra un nouveau mot de passe rapidement.
                        </p>
                    </div>

                    {done ? (
                        <div
                            data-testid="mdp-success"
                            className="bg-ink-600 border border-ice/30 rounded-xl p-8 text-center"
                        >
                            <div className="w-14 h-14 rounded-full bg-ice/15 flex items-center justify-center mx-auto">
                                <Check className="text-ice" size={26} />
                            </div>
                            <h3 className="font-serif text-2xl mt-5">Demande enregistrée</h3>
                            <p className="mt-3 text-white/75 leading-relaxed">
                                Si un compte existe avec cet email, notre équipe vous communiquera un nouveau mot de passe sous peu (par email, SMS ou WhatsApp).
                            </p>
                            <Link
                                to="/login"
                                data-testid="mdp-back-cta"
                                className="inline-block mt-6 text-sm text-ice hover:text-white transition-colors underline underline-offset-4"
                            >
                                Revenir à la connexion
                            </Link>
                        </div>
                    ) : (
                        <form
                            data-testid="mdp-form"
                            onSubmit={submit}
                            className="bg-ink-600 border border-ice/10 rounded-xl p-8 space-y-5"
                        >
                            <label className="block">
                                <span className="text-xs tracking-[0.2em] text-white/60 uppercase">Votre email</span>
                                <div className="relative mt-2">
                                    <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
                                    <input
                                        data-testid="mdp-input-email"
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        autoComplete="email"
                                        className="w-full bg-ink-800 border border-white/15 text-white placeholder-white/40 focus:border-ice focus:ring-1 focus:ring-ice rounded-md pl-10 pr-4 py-3 outline-none text-sm"
                                    />
                                </div>
                            </label>

                            {error && (
                                <div data-testid="mdp-error" className="text-sm text-red-300 bg-red-500/10 border border-red-400/30 rounded-md px-4 py-3">
                                    {error}
                                </div>
                            )}

                            <button
                                type="submit"
                                disabled={submitting}
                                data-testid="mdp-submit-button"
                                className="w-full bg-ice text-ink-900 hover:bg-white disabled:opacity-60 transition-colors px-7 py-3.5 rounded-md font-medium tracking-wide"
                            >
                                {submitting ? "Envoi…" : "Envoyer ma demande"}
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
